"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateString = getDateString;
exports.getTimeString = getTimeString;
function getDateString(date, culture) {
    const d = date.toDate();
    return d.toLocaleDateString(culture);
}
function getTimeString(date, culture) {
    const d = date.toDate();
    return d.toLocaleTimeString(culture);
}
//# sourceMappingURL=formatting.js.map